import { render, staticRenderFns } from "./ArrowDownLight.vue?vue&type=template&id=8b357844"
import script from "./ArrowDownLight.vue?vue&type=script&lang=js"
export * from "./ArrowDownLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports